import { apiGet } from "@/lib/api";

// Strategy page dir → trades API root. Covered Calls has its own endpoint.
const SPREAD_API: Record<string, string> = {
  "vertical-spreads": "/vs",
  "0dte-vertical-spreads": "/vs0",
  "equity-vertical-spreads": "/vse",
};

/**
 * Open trades shown on one strategy page for one account — the same ledger
 * rows and index/stock split the page itself uses.
 */
export async function countOpenTrades(
  dir: string,
  accountHash: string,
  indexUnderlyings: Set<string>,
  tokenId?: number,
): Promise<number> {
  const q = encodeURIComponent(accountHash);
  if (dir === "stock-trading") {
    // Live broker positions (the page's whole table).
    const r = await apiGet<{ securitiesAccount?: { positions?: { longQuantity?: number; shortQuantity?: number }[] } }>(
      `/accounts/${q}/positions?tokenId=${tokenId ?? -1}`,
    );
    return (r.securitiesAccount?.positions ?? [])
      .filter((p) => (p.longQuantity ?? 0) > 0 || (p.shortQuantity ?? 0) > 0).length;
  }
  if (dir === "covered-calls") {
    const r = await apiGet<{ positions: unknown[] }>(`/positions/open-covered-calls?accountHash=${q}`);
    return r.positions.length;
  }
  const api = SPREAD_API[dir];
  if (!api) return 0;
  const isIndex = (sym: string) =>
    sym.startsWith("/") || indexUnderlyings.has(sym.replace(/^\$/, ""));
  const wantIndex = dir !== "equity-vertical-spreads";
  const rows = await apiGet<{ status: string; symbol: string }[]>(`${api}/trades?account=${q}`);
  return rows.filter(
    (t) => t.status === "open" && !!t.symbol && isIndex(t.symbol) === wantIndex,
  ).length;
}
